import { TextField } from '@mui/material';
import NumberFormat from 'react-number-format';
import { PNumberFieldProps } from '@/components/atoms/NumberField/types';
import { lockedTextFieldSx } from '@/components/atoms/TextField/lockedSx';
import { mergeSx } from '@/utils/cssStyles';

/**
 * `PNumberField` is the design system atom for numeric text input (wraps `react-number-format`'s
 * `NumberFormat` with a MUI `TextField`).
 *
 * Adds a third `state`: alongside `enabled`/`disabled`, `locked` renders a readable filled
 * treatment (instead of MUI's dimmed disabled look) for a value the user needs to read but can't
 * edit right now.
 */
export const PNumberField = ({ state = 'enabled', sx, ...other }: PNumberFieldProps) => {
  return (
    <NumberFormat
      customInput={TextField}
      disabled={state !== 'enabled'}
      sx={mergeSx(state === 'locked' ? lockedTextFieldSx : undefined, sx)}
      {...other}
    />
  );
};
